// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4273":"5041379bf2d0b54a","7577":"ab1afb265948603a","7749":"b48825dec1e0eaca"}[chunkId] + ".js";
};